import { Label } from "../../../components/Label";
import { Input } from "../../../components/Input";
import { Select } from "../../../components/Select";
import { Button } from "../../../components/Button";
import { Icon } from "../../../components/core/Icon";
import { Hairline } from "../../../components/Hairline";
import * as uuid from 'uuid';
import { NumberInput } from "../../../components/NumberInput";

const PackageType = {
	COPO: "COPO",
	GALAO: "GALAO",
	GARRAFA: "GARRAFA",
	JARRA: "JARRA",
	LATA: "LATA",
	LONGNECK: "LONGNECK",
	OTHER: "OTHER"
}

const PackageNames = {
	COPO: "Copo",
	GALAO: "Galão",
	GARRAFA: "Garrafa",
	JARRA: "Jarra",
	LATA: "Lata",
	LONGNECK: "Longneck",
	OTHER: "Outro"
}

const availablePackages = [
	PackageType.COPO,
	PackageType.GALAO,
	PackageType.GARRAFA,
	PackageType.JARRA,
	PackageType.LATA,
	PackageType.LONGNECK,
	PackageType.OTHER
];

const VolumeUnit = {
	mL: "ml",
	L: "L"
}

const availableUnits = [
	VolumeUnit.mL,
	VolumeUnit.L
]

const SizeItem = ({ size, sizeLength, onDeleteSize, onChange }) => {
	return (
		<div>
			<div className="d-flex mt-15">
				<Select
					design="two"
					label="Tipo de embalagem"
					onChange={(e) => {
						onChange && onChange({
							...size,
							name: e.target.value != "Selecione uma embalagem" ? `${PackageNames[e.target.value]} - ${size.amount}${size.unit}` : null,
							package: e.target.value != "Selecione uma embalagem" ? e.target.value : null
						})
					}}
					className="flex-1"
					value={size.package}
					options={[
						{ label: "Selecione uma embalagem", value: null, selected: !size.package },
						...(availablePackages.map((p) => ({ label: PackageNames[p], value: p })))
					]}
				/>
				{sizeLength > 2 && (
					<Button design="default-icon-2" onClick={onDeleteSize} className="ml-15" >
						<Icon name="trash-alt" size="lg" />
					</Button>
				)}
			</div>

			<div className="d-flex mt-35">
				<NumberInput
					label="Volume"
					precision={size.unit != VolumeUnit.mL ? 1 : 0}
					design="four"
					placeholder="---"
					value={size.amount}
					onChange={(e, maskedValue, floatValue) => {
						onChange && onChange({
							...size,
							name: !!maskedValue ? `${PackageNames[size.package]} - ${e.target.value}${size.unit}` : null,
							amount: floatValue
						})
					}}
				/>
				<Select
					design="two"
					label="Medida"
					onChange={(e) => {
						onChange && onChange({
							...size,
							name: e.target.value != "Selecione uma medida" ? `${PackageNames[size.package]} - ${size.amount}${e.target.value}` : null,
							unit: e.target.value != "Selecione uma medida" ? e.target.value : null
						})
					}}
					className="ml-15 w-100"
					value={size.unit}
					options={[
						{ label: "Selecione uma medida", value: null },
						...(availableUnits.map((u) => ({ label: u, value: u })))
					]}
				/>
			</div>
		</div>
	)
}

const SetDrinkSizesStep = ({ category, onChange }) => {

	const handler = (sizes) => {
		onChange && onChange({ ...category, sizes })
	}

	return (
		<>
			<Label>{category.sizes.length > 1 ? "Quais são os tamanhos?" : "Qual é o tamanho?"}</Label>
			{category.sizes.map((size, sizeIdx, sizes) => {
				return (
					<>
						<SizeItem
							size={size}
							key={size.ref_id}
							sizeLength={sizes.length}
							onChange={(size) => {
								sizes[sizeIdx] = size;
								handler(sizes);
							}}
							onDeleteSize={() => handler(sizes.filter((s) => s.ref_id != size.ref_id))}
						/>
						{sizes.length > 1 && sizeIdx != (sizes.length - 1) && <Hairline />}
					</>
				)
			})}
			{category.sizes.length > 1 && (
				<Button design="default-2" className="w-100 mt-20" onClick={() => handler([...category.sizes, { name: "", type: 'size', ref_id: uuid.v4() }])}>
					Adicionar tamanho
				</Button>
			)}
		</>
	);
};

export default SetDrinkSizesStep;
